import type { StockLocation } from "./types";

type StockLocationConfiguration = Pick<StockLocation, "columns">;

export function stockLocationDisplayName(
    location: StockLocationConfiguration,
    level: number | null | undefined,
    column: number | null | undefined
): string {
    if (
        level == null ||
        column == null ||
        !Number.isInteger(level) ||
        !Number.isInteger(column) ||
        level < 1 ||
        column < 1 ||
        column > location.columns
    ) {
        return "-";
    }

    const firstLabel = alphabeticalLabel(((level - 1) * 2) + 1);
    const secondLabel = alphabeticalLabel(((level - 1) * 2) + 2);
    const middleColumn = Math.floor(location.columns / 2);

    if (location.columns % 2 !== 0 && column === middleColumn + 1) {
        return `${firstLabel}/${secondLabel}`;
    }

    return column <= middleColumn ? secondLabel : firstLabel;
}

function alphabeticalLabel(number: number): string {
    const characters: string[] = [];

    while (number > 0) {
        number -= 1;
        characters.push(String.fromCharCode(65 + (number % 26)));
        number = Math.floor(number / 26);
    }

    return characters.reverse().join("");
}
